import React, { useState } from 'react'
import { Button, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import axios from "axios"
import ProtectedRoute from './ProtectedRoute';
import Cookies from 'universal-cookie';
import { kioskModel, teleConsultationModel } from '../Axios/AxiosConfig';
import { setTokens } from './AuthUtil';
import { Auth_URL } from '../Axios/config';
import { getDynamicLogo } from '../getDynamicLogo';

function Login() {

    let navigate = useNavigate();

    let [user, setUser] = useState('');

    let [password, setPassword] = useState('');

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState('');

    const cookies = new Cookies();

    const [isVisible, setIsVisible] = useState(false);

    function addCountryCodeIfNumber(input) {
        if (!isNaN(input) && input.trim() !== '') {
            return '+91' + input;
        }
        return input;
    };

    const validateInput = (input) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/;
        return emailRegex.test(input) || phoneRegex.test(input);
    };

    const handleChange = (event) => {
        setUser(event.target.value);
        setError('');
    };

    const handleChange2 = (event) => {
        setPassword(event.target.value);
        setError('');
    };

    const handleSubmit = async () => {
        if (validateInput(user)) {
            setLoading(true);
            try {
                let res = await axios.post(`${Auth_URL}Signin`, {
                    email: addCountryCodeIfNumber(user),
                    password
                });

                if (res.status === 200) {
                    const { accessToken, refreshToken, id } = res.data;

                    setTokens(accessToken, refreshToken);

                    let kiosk_response = await kioskModel.get(`/KioskSignup/${id}`);
                    
                    let doctor_response = await teleConsultationModel.get(`/getDoctor_details/${id}`);

                    if (kiosk_response.status === 200) {
                        cookies.set('kiosk_details', JSON.stringify(kiosk_response.data), { path: '/', maxAge: 30 * 24 * 60 * 60 });
                    }

                    if (doctor_response.status === 200) {
                        cookies.set('Doctor_details', JSON.stringify(doctor_response.data), { path: '/', maxAge: 30 * 24 * 60 * 60 });
                    }

                    navigate('/');
                }
            } catch (error) {
                setError(error?.response?.data?.error || "Something went wrong!");
            } finally {
                setLoading(false); // Stop loader
            }
        } else {
            setError('Invalid input. Please enter a valid email or phone number.');
        }
    };

    const RequestOTP = async (event) => {
        setLoading(true); // Start loader
        event.preventDefault();
        if (validateInput(user)) {
            try {
                let res = await axios.post(`${Auth_URL}Passwordless-signin`, {
                    user: addCountryCodeIfNumber(user)
                });

                if (res.status === 200) {
                    cookies.set('OTP-Session', res?.data?.session);
                    cookies.set("user", addCountryCodeIfNumber(user));
                    navigate('/loginwithotp');
                }
            } catch (error) {
                setError(error?.response?.data?.error || "Something went wrong!");
            } finally {
                setLoading(false); // Stop loader
            }
        } else {
            setError('Invalid input. Please enter a valid email or phone number.');
        }
    };

    const handleChangePassword = (e) => {
        const value = e.target.value;
        setPassword(value);

        if (value === '') {
            setIsVisible(false);
        }
    };

    const handleIconClick = () => {
        if (password !== '') {
            setIsVisible((prev) => !prev);
        }
    };

    let iconSrc = './icons/create_password.png';

    if (password !== '') {
        iconSrc = isVisible ? './icons/seen_icon.png' : './icons/unseen_icon.png';
    }

    return (
        <div className='Login-page'>
            <nav>
                <div>
                    <img
                        src="https://v2.aiwell.in/static/media/Aiwell%20version%202%20website%20logo.d98414bba22690b67307.png"
                        className="overflow-hidden transition-all w-40"
                        alt=""
                    />
                </div>
            </nav>
            <div className='Login-content-items'>
                <p>Sign in</p>
                <p>Welcome</p>
                <div className='login-text-inputs'>
                    <div className="input-container">
                        <img src='./icons/login.png' alt="Login" />
                        <input type='text' placeholder='Enter mobile / Email id' onChange={handleChange} />
                    </div>
                    <div className="input-container">
                        <img
                            src={iconSrc}
                            alt="Password Icon"
                            onClick={handleIconClick}
                            style={{ cursor: password !== '' ? 'pointer' : 'default' }}
                        />
                        <input
                            type={isVisible ? 'text' : 'password'}
                            placeholder="Enter password"
                            onChange={handleChangePassword}
                            value={password}
                        />
                    </div>
                </div>
                {error && <p style={{ color: 'red' }}>{error}</p>}

                <div className='login-action-buttons'>
                    <Button
                        style={{
                            width: '100%',
                            textTransform: 'none',
                            borderRadius: '5px',
                            backgroundColor: 'var(--themePrimaryColor, #DA6E0B)',
                            color: 'white',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: "10px"
                        }}
                        onClick={handleSubmit}
                        disabled={loading} // Disable button when loading
                    >
                        {loading ? (
                            <div style={{ position: "relative", width: "2rem", height: "2rem" }}>
                                <CircularProgress style={{ width: "100%", height: "100%", color: "#FFF" }} thickness={5} />
                            </div>
                        ) : "Sign in"}
                    </Button>

                    <Button
                        style={{
                            width: '100%',
                            textTransform: 'none',
                            borderRadius: '5px',
                            backgroundColor: 'var(--themeSecondaryColor, #f4ecd6)',
                            color: 'var(--themePrimaryColor, #DA6E0B)',
                            border: "2px solid var(--themePrimaryColor, #DA6E0B)",
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: "10px"
                        }}
                        onClick={RequestOTP}
                        disabled={loading} // Disable button when loading
                    >
                        {loading ? (
                            <div style={{ position: "relative", width: "2rem", height: "2rem" }}>
                                <CircularProgress style={{ width: "100%", height: "100%", color: "var(--themePrimaryColor, #DA6E0B)" }} thickness={5} />
                            </div>
                        ) : "Sign in with OTP"}
                    </Button>

                    <ProtectedRoute />
                </div>

                <p>By signing in, you accept the terms & conditions</p>
            </div>
        </div>
    );
}

export default Login;
